import ICVLibraryAdvanceSearch from '../types/ICVLibraryAdvanceSearch';

export default {} as ICVLibraryAdvanceSearch;
